import '../styles/about.css';

const About = () => {
    return (
        <section id="about" className="about">
            <div className="section-header">
                <span className="subtitle">About Me</span>
                <h2>Who I Am</h2>
            </div>
            <div className="about-content">
                <div className="about-visual">
                    <div className="abstract-design">
                        <div className="design-element"></div>
                        <div className="design-element"></div>
                        <div className="design-element"></div>
                        <div className="experience-badge">
                            <span className="years">5+</span>
                            <span className="text">Years<br />Experience</span>
                        </div>
                    </div>
                </div>
                <div className="about-text">
                    <p className="lead-text">Transforming ideas into seamless digital experiences.</p>
                    <p className="description">As a passionate developer, I specialize in building elegant, functional, and user-centered web applications. With a keen eye for design and a commitment to writing clean, efficient code, I thrive on crafting solutions that merge creativity with technology.</p>

                    <div className="stats-grid">
                    <div className="stat-item">
                            <div className="stat-number" data-count="20">50+</div>
                            <div className="stat-label">Projects Delivered</div>
                        </div>
                        <div className="stat-item">
                            <div className="stat-number" data-count="10">10+</div>
                            <div className="stat-label">Technologies Used</div>
                        </div>
                        <div className="stat-item">
                            <div className="stat-number" data-count="3">3+</div>
                            <div className="stat-label">Industries Served</div>
                        </div>
                    </div>

                    <div className="skills-container">
                        <div className="skills-group">
                            <h3>Technical Skills</h3>
                            <div className="skills-grid">
                                <div className="skill-category">
                                    <h4>Frontend</h4>
                                    <div className="skill-tags">
                                        <span className="skill-tag frontend-tag">React</span>
                                        <span className="skill-tag frontend-tag">NextJS</span>
                                        <span className="skill-tag frontend-tag">JavaScript</span>
                                        <span className="skill-tag frontend-tag">HTML/CSS</span>
                                    </div>
                                </div>
                                <div className="skill-category">
                                    <h4>Backend</h4>
                                    <div className="skill-tags">
                                        <span className="skill-tag backend-tag">Node.js</span>
                                        <span className="skill-tag backend-tag">Java</span>
                                        <span className="skill-tag backend-tag">SQL</span>
                                        <span className="skill-tag backend-tag">NoSQL</span>
                                    </div>
                                </div>
                                <div className="skill-category">
                                    <h4>Tools & Design</h4>
                                    <div className="skill-tags">
                                        <span className="skill-tag tools-tag">Storybook</span>
                                        <span className="skill-tag tools-tag">Git</span>
                                        <span className="skill-tag tools-tag">Figma</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <div className="skills-container">
                        <div className="skills-group">
                            <h3>Technical Skills</h3>
                            <div className="skill-bars">
                                <div className="skill-bar">
                                    <div className="skill-info">
                                        <span>Frontend Development</span>
                                    </div>
                                    <div className="progress-line"><span className="frontend"></span></div>
                                </div>
                                <div className="skill-bar">
                                    <div className="skill-info">
                                        <span>Backend Development</span>
                                    </div>
                                    <div className="progress-line"><span className="backend"></span></div>
                                </div>
                                <div className="skill-bar">
                                    <div className="skill-info">
                                        <span>UI/UX Design</span>
                                    </div>
                                    <div className="progress-line"><span className="design"></span></div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
        </section>
    )
}

export default About;